<div class="modal-small">
    <h4>Rename View</h4>
    <div class="divider"></div>
    <div class="modal-content">
        <div class="form-group">
            <label for="viewName" class="subtitle-2">View Name</label>
            <input 
                type="text" 
                id="viewName" 
                class="form-control" 
                [(ngModel)]="newName" 
                (keyup.enter)="save()"
                autofocus />
        </div>
    </div>
    <div class="divider"></div>
    <div class="modal-actions">
        <button class="btn btn-primary" (click)="save()" [disabled]="!newName || !newName.trim()">Save</button>
        <button class="btn btn-secondary" (click)="cancel()">Cancel</button>
    </div>
</div>
